import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const LanguageName = ({
  languageKey,
  displayCountryName = true
}) => {
  if (!languageKey) return null;
  const language = displayCountryName ? languageKey : languageKey.split('-')[0];
  const key = `SharedI18nStrings.languageNames.${language}`;
  return isValidI18nKey(key) ? /*#__PURE__*/_jsx(Text, {
    as: "span",
    color: "text-core-subtle",
    children: ` (${I18n.text(key)})`
  }) : null;
};
export default LanguageName;